import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TwDocumentacionCamViewModel } from 'src/app/components/_mantenimiento/campanias/campania/documentacioncam/documentacioncam.types';
import { TCampaniaEspecificaViewModel } from 'src/app/components/_mantenimiento/campanias/campaniasespecificas/campaniaespecifica.types';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { TwSolicitudCamViewModel } from '../../../types/solicitudcam-datosbasicos.types';
@Component({
    selector: 'app-solicitud-documentacion-header',
    templateUrl: './solicitud-documentacion-header.component.html',
    styleUrls: ['./solicitud-documentacion-header.component.scss'],
})
export class SolicitudDocumentacionHeaderComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() solicitudCam: TwSolicitudCamViewModel;
    @Input() campaniaEspecifica: TCampaniaEspecificaViewModel;
    @Input() formGroup: FormGroup;
    @Input() disabled: boolean;
    @Input() prefixFormControlNameTipoDoc: string;

    isCollapsedCabecera = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.campaniaEspecifica?.currentValue) {
            this.updateForm();
        }
    }

    /**
     * Se acgtualizan los valores del formulario empezando con los dos controles básicos:
     * - IdCampaniaDescripcion
     * - AdjuntarDocumentacion
     * El resto de controles se actualizarán de forma dinámica en función de la configuración de la documentación para la campaña.
     * Esto solo será así, si el campo AdjuntarDocumentacion está a true.
     */
    private updateForm(): void {
        this.formGroup.patchValue({
            IdCampaniaDescripcion: this.campaniaEspecifica?.Descripcion || '',
            AdjuntarDocumentacion: this.campaniaEspecifica?.AdjuntarDocumentacion || false,
        });

        if (this.campaniaEspecifica?.AdjuntarDocumentacion && this.campaniaEspecifica?.Documentacion?.length > 0) {
            this.campaniaEspecifica?.Documentacion.forEach(doc => {
                // const propertyIndex = this.prefixFormControlNameTipoDoc + doc.IdTipoDocumentacion;
                this.formGroup.patchValue({
                    propertyIndex: doc.Obligatoria,
                });
            });
        }

        this.form = this.formGroup;
    }

    trackDocumentacionCam(index: number, documentacionCam: TwDocumentacionCamViewModel): number {
        return documentacionCam?.Id || 0;
    }
}
